import { useState } from "react";
import { toast } from "react-toastify";
import { Edit, Trash } from "iconsax-reactjs";
import SkyroomModal from "./SkyroomModal";
import type { Skyroom } from "../../../services/webServices/skyroom/types";
import { deleteSkyroom } from "../../../services/webServices/skyroom/delete";

type Props = {
  room: Skyroom;
  onSuccess: () => void;
  onDelete: (id: number) => void;
};

export default function SkyroomAction({ room, onSuccess, onDelete }: Props) {

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const handleDelete = async ( ): Promise<boolean> => {
    const success = await deleteSkyroom({ id: room.id });
    if (!success) return false;
    toast.success("اتاق اسکای‌روم با موفقیت حذف شد");
    onDelete(room.id);
    return true;
  };

  return (
    <div className="flex items-center justify-center gap-1">
      <button
        type="button"
        onClick={() => setIsEditModalOpen(true)}
        className="p-2 rounded-lg text-gray-600 hover:bg-primaryVar-100 hover:text-primaryVar transition-colors"
        title="ویرایش اتاق"
      >
        <Edit variant="Outline" size="14" />
      </button>

      <button
        type="button"
        onClick={handleDelete}
        className="p-2 rounded-lg text-gray-600 hover:bg-red-50 hover:text-red-600 transition-colors"
        title="حذف اتاق"
      >
        <Trash variant="Outline" size="14" />
      </button>

      <SkyroomModal 
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        room={room}
        onSuccess={onSuccess}
      />
    </div>
  );
};